import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

import { FailedInfraResponse } from "../_common/InfraResponse"

const PATH = "/me"

type GetMe = FailedInfraResponse | User

export const fetchGetMe = defineFetcher((): Promise<GetMe> => {
  return GET(PATH)
})

export interface User {
  error?: undefined
  id: number
  name: string
  name_kana?: undefined
  email: string
  email_verified_at: string
  phone_number?: undefined
  sex: string
  birth_year: number
  birth_month: number
  birth_date: number
  year: string
  graduates_in?: number
  grad_year?: undefined
  job_hunting_start_time?: undefined
  number_of_applying_companies?: undefined
  number_of_keeping_job_offers: number
  student_long_internship_purpose_id?: undefined
  profile_img: string
  registered_via?: undefined
  yougrow_student_id?: undefined
  hobby_skill?: undefined
  created_at: string
  updated_at: string
  deleted_at?: undefined
  provider_name: string
  provider_id: string
  provider_token: string
  provider_token_secret?: undefined
  user_type: string
  company_id?: undefined
  cover_img_filename: string
  introduction_key: string
  redis_unique_key?: undefined
  allow_scout: boolean
  accessed_at: string
  web_sessions: number
  reference_source?: undefined
  allow_mail_magazine: boolean
  allow_favorite_remind: boolean
  allow_job_approval_reminder_mail: boolean
  fcm_token?: undefined
  push_notifications_count: number
  is_from_nativeapp: number
  from_next: number
  added_mail_list: number
  spreadsheet_range?: undefined
  confirmed_advanced_year: number
  new_grads_campaign: number
  has_right_of_campaign_gift: number
  campaign_introduction_confirmed: number
  tmp_foreign_language?: undefined
  tmp_development?: undefined
  programming_course_completed: number
  school: string
  faculty: string
  lastLoginAt: string
  registeredAt: string
  jwt: string
  hasUnconfirmedScout: boolean
  hasPassword: boolean
  longInternshipApplicationNumber: number
  company?: undefined
  intern_motivation?: undefined
  detail_occupations: any[]
  line_account?: undefined
  educations: Education[]
}

interface Education {
  id: number
  school_id: number
  school: string
  faculty: string
  category_id: number
  created_at: string
  updated_at: string
  deleted_at?: undefined
  user_id: number
  start_on: string
  end_on?: undefined
  ongoing: boolean
  content?: undefined
  link?: undefined
  img_filename?: undefined
}
